/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Modal from 'react-bootstrap/Modal';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import el from 'date-fns/locale/pt-BR';
import { ApplicationState } from 'store';
import { UserContactSelectTypes, UserContactsState } from 'store/modules/user_contacts_store/types';
import Select from 'react-select';
import { ProfileState } from 'store/modules/profile_store/types';
import moment from 'moment';
import SquareLoader from 'components/atoms/square_loader';
import _ from 'underscore';
import {
  createProgress,
  createTask,
  createTaskAttachment,
  createTaskComment,
  deleteProgress,
  deleteTask,
  destroyTaskAttachment,
  updateProgress,
  updateTask,
  createProgressComment,
  createProgressAttachment,
} from 'store/modules/management_store/actions';
import { ManagementState, TaskData, BiddingData } from 'store/modules/management_store/types';
import CommentItem from 'components/molecules/comment_item';
import CommentInput from 'components/molecules/comment_input';
import AttachmentItem from 'components/molecules/attachment_item';
import { BulletinBiddingsTypes } from 'store/modules/bulletins_store/types';
import companyId from 'services/company_id';
import createTrack from 'services/actions/tracker_actions';
import { track } from 'services/tracking';
import { useAudioRecorderController } from 'hooks/useAudioRecorderController';
import { speechToText } from 'services/actions/chatbot_actions';
import { AudioWaveRecorder } from 'components/atoms/audio_wave';
import { ContainerAudioPreview, DeleteButton, InputCompleted } from './styles';

registerLocale('el', el);

interface ManagementTaskProps {
  modalManagementTaskOpened: boolean;
  setModalManagementTaskOpened: React.Dispatch<React.SetStateAction<boolean>>;
  bidding: BulletinBiddingsTypes | BiddingData;
  taskType: string;
  task?: TaskData;
}

const ManagementTask = (props: ManagementTaskProps) => {
  const {
    modalManagementTaskOpened,
    setModalManagementTaskOpened,
    bidding,
    taskType,
    task = null,
  } = props;
  const [deadlineDate, setDeadLineDate] = useState<Date>(
    task !== null ? new Date(task.deadline) : new Date(),
  );
  const [finishedDate, setFinishedDate] = useState<Date | null>(
    task !== null && task.finished_date ? new Date(task?.finished_date) : null,
  );
  const [title, setTitle] = useState<string>(task !== null ? task.title : '');
  const [taskDescription, setTaskDescription] = useState<string>(
    task !== null ? task.description : '',
  );
  const [userContactsList, setUserContactsList] = useState<Array<UserContactSelectTypes>>([]);
  const [saveClicked, setSaveClicked] = useState<boolean>(false);
  const [selectedUserContact, setselectedUserContact] = useState<number | null>(
    task !== null ? task.responsible_id : 0,
  );
  const [selectedCompleted, setSelectedCompleted] = useState<boolean>(
    task !== null ? task.status_task_id === 'finished' : false,
  );
  const [showError, setShowError] = useState<boolean>(false);
  const [showAttachmentError, setShowAttachmentError] = useState<boolean>(false);
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const [showValidationError, setShowValidationError] = useState<boolean>(false);
  const [file, setFile] = useState<any>(null);
  const [attachmentOpened, setAttachmentOpened] = useState<boolean>(false);
  const [fileDescription, setFileDescription] = useState<string>('');
  const [uploadProgress, setUploadProgress] = useState<number>(0);
  const [deletingTask, setDeletingTask] = useState<boolean>(false);
  const { waveRef, isRecording, startRecording, cancelRecording, stopRecording } =
    useAudioRecorderController();
  const [transcribing, setTranscribing] = useState(false);

  const dispatch = useDispatch();

  const { management, request } = useSelector<ApplicationState, ManagementState>(
    (state) => state.session.management,
  );

  const taskScope = bidding ? 'client' : management.filtered_by;

  const { user_contacts } = useSelector<ApplicationState, UserContactsState>(
    (state) => state.storage.userContacts,
  );
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const SHORT_DELAY = 2000;
  const LONG_DELAY = 5000;

  useEffect(() => {
    if (!task) return;

    setTitle(task.title);
    setTaskDescription(task.description);
    setDeadLineDate(task !== null ? new Date(task.deadline) : new Date());
    setFinishedDate(task !== null && task.finished_date ? new Date(task?.finished_date) : null);
    setselectedUserContact(task !== null ? task.responsible_id : 0);
    setSelectedCompleted(task !== null ? task.status_task_id === 'finished' : false);
  }, [task]);

  useEffect(() => {
    if (task === null) {
      setDeadLineDate(new Date());
      setFinishedDate(null);
      setTitle('');
      setTaskDescription('');
    }
  }, [modalManagementTaskOpened]);

  useEffect(() => {
    if (!request.create_task_attachment.error) return;

    setShowAttachmentError(true);
    setTimeout(() => {
      setShowAttachmentError(false);
    }, SHORT_DELAY);
  }, [request.create_task_attachment.error]);

  useEffect(() => {
    if (!request.create_progress_attachment.error) return;

    setShowAttachmentError(true);
    setTimeout(() => {
      setShowAttachmentError(false);
    }, SHORT_DELAY);
  }, [request.create_progress_attachment.error]);

  useEffect(() => {
    if (!request.create_progress_attachment.loaded || !request.create_task_attachment.loaded)
      return;

    setUploadProgress(0);
  }, [request.create_progress_attachment.loaded, request.create_task_attachment.loaded]);

  useEffect(() => {
    if (title !== '' && taskDescription !== '') setShowValidationError(false);
  }, [title, taskDescription]);

  useEffect(() => {
    setUserContactsList(
      user_contacts?.map((user_contact) => {
        return { label: user_contact.nome, value: user_contact.id };
      }),
    );
    if (selectedUserContact === 0) setselectedUserContact(profile.id);
  }, []);

  useEffect(() => {
    if (!saveClicked) return;
    if (
      request.create_tasks.loading ||
      request.update_tasks.loading ||
      request.create_progress.loading ||
      request.update_progress.loading ||
      request.delete_task.loading ||
      request.delete_progress.loading
    )
      return;

    if (
      request.create_tasks.loaded ||
      request.update_tasks.loaded ||
      request.create_progress.loaded ||
      request.update_progress.loaded ||
      request.delete_task.loaded ||
      request.delete_progress.loaded
    ) {
      setShowSuccess(true);
    }
  }, [
    request.create_tasks.loaded,
    request.update_tasks.loaded,
    request.create_progress.loaded,
    request.update_progress.loaded,
    request.delete_task.loaded,
    request.delete_progress.loaded,
  ]);

  useEffect(() => {
    if (!showSuccess) return;

    setTimeout(() => {
      setShowSuccess(false);
      setModalManagementTaskOpened(false);
    }, SHORT_DELAY);
  }, [showSuccess]);

  useEffect(() => {
    if (!saveClicked) return;
    if (
      request.create_tasks.loading ||
      request.update_tasks.loading ||
      request.create_progress.loading ||
      request.update_progress.loading ||
      request.delete_task.loading ||
      request.delete_progress.loading
    )
      return;

    if (
      request.create_tasks.error ||
      request.update_tasks.error ||
      request.create_progress.error ||
      request.update_progress.error ||
      request.delete_task.error ||
      request.delete_progress.error
    ) {
      setShowError(true);
      setDeletingTask(false);
    }
  }, [
    request.create_tasks.error,
    request.update_tasks.error,
    request.create_progress.error,
    request.update_progress.error,
    request.delete_task.error,
    request.delete_progress.error,
  ]);

  useEffect(() => {
    if (!showError) return;

    setTimeout(() => {
      setShowError(false);
    }, SHORT_DELAY);
  }, [showError]);

  useEffect(() => {
    if (!showValidationError) return;

    setTimeout(() => {
      setShowValidationError(false);
    }, LONG_DELAY);
  }, [showValidationError]);

  useEffect(() => {
    if (selectedCompleted && !task?.finished_date) return setFinishedDate(new Date());

    if (!selectedCompleted) return setFinishedDate(null);

    return setFinishedDate(finishedDate);
  }, [selectedCompleted]);

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    if (!task) return;

    const formData = new FormData();
    formData.append('selectedFile', file);
    formData.append('biddingId', String(bidding?.id ?? task?.bidding_id ?? ''));
    formData.append('refererId', task?.id.toString());
    formData.append('description', fileDescription);
    formData.append('referer', 'task');
    formData.append('companyId', companyId(profile).toString());
    if (taskType === 'progress')
      dispatch(createProgressAttachment(formData, task?.id, setUploadProgress));
    if (taskType === 'task') dispatch(createTaskAttachment(formData, task?.id, setUploadProgress));
  };

  const handleFile = async (event: any) => {
    await setFile(event.target.files[0]);
  };

  const handleFinishedDate = () => {
    if (finishedDate) return moment.parseZone(finishedDate).format();

    if (!finishedDate && selectedCompleted) return moment.parseZone(new Date()).format();

    return null;
  };

  const saveTask = () => {
    if (title === '' || taskDescription === '') {
      setShowValidationError(true);
      return;
    }

    if (task) {
      if (taskType === 'progress')
        dispatch(
          updateProgress({
            id: task.id,
            title,
            description: taskDescription,
            deadline: moment.parseZone(deadlineDate).format(),
            companyId: companyId(profile),
          }),
        );
      else
        dispatch(
          updateTask({
            id: task.id,
            title,
            description: taskDescription,
            deadline: moment.parseZone(deadlineDate).format(),
            finished_date: handleFinishedDate(),
            responsible_id: selectedUserContact,
            status_task_id: selectedCompleted || taskType !== 'task' ? 'finished' : 'in_progress',
            companyId: companyId(profile),
            scope: taskScope,
          }),
        );
    }

    if (!task && bidding) {
      createTrack('Gestão de Licitações - Criou uma tarefa/andamento');
      track('gestao.criou_tarefa_andamento');
      if (taskType === 'progress')
        dispatch(
          createProgress({
            bidding_id: Number(bidding.bidding_id) || bidding.id,
            title,
            description: taskDescription,
            deadline: moment.parseZone(deadlineDate).format(),
            companyId: companyId(profile),
          }),
        );
      else
        dispatch(
          createTask({
            bidding_id: Number(bidding.bidding_id) || bidding.id,
            client_id: companyId(profile),
            created_by_id: profile.id,
            deadline: moment.parseZone(deadlineDate).format(),
            description: taskDescription,
            finished_date: handleFinishedDate(),
            responsible_id: selectedUserContact,
            status_task_id: selectedCompleted || taskType !== 'task' ? 'finished' : 'in_progress',
            title,
          }),
        );
    }

    setSaveClicked(true);
  };

  const destroyTask = () => {
    if (task) {
      if (taskType === 'progress') return dispatch(deleteProgress(task.id, companyId(profile)));
      return dispatch(deleteTask(task.id, companyId(profile)));
    }

    return false;
  };

  const isFieldDisabled = () => {
    if (!task) return false;
    return task?.created_by_id !== profile.id && task?.responsible_id !== profile.id;
  };

  const createManagementComment = (comment: string) => {
    if (taskType === 'progress') return dispatch(createProgressComment(task?.id || 0, comment));

    return dispatch(createTaskComment(task?.id || 0, comment));
  };

  const handleRecordFinish = async (blob: Blob) => {
    const formData = new FormData();
    formData.append('audio', blob, 'audio.webm');

    try {
      setTranscribing(true);
      createTrack(
        `${task ? 'Editar' : 'Adicionar'} ${
          taskType === 'task' ? ' Tarefa' : ' Andamento'
        } - Ditar`,
      );

      const response = await speechToText(formData);

      if (response.status === 200) {
        setTaskDescription(response.data?.text || '');
      }
    } catch (error) {
      console.error('Erro na transcrição:', error);
    } finally {
      setTranscribing(false);
    }
  };

  if (deletingTask)
    return (
      <Modal show={modalManagementTaskOpened} size="sm">
        <div className="modal-header">
          <h5 className="modal-title" id="staticBackdropLabel">
            {task ? 'Editar' : 'Adicionar'}
            {taskType === 'task' ? ' Tarefa' : ' Andamento'}
          </h5>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => {
              setModalManagementTaskOpened(false);
            }}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body">{`Deseja remover ${
          taskType === 'task' ? 'esta tarefa' : 'este andamento'
        }?`}</div>
        <div className="modal-footer d-flex justify-content-around">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setDeletingTask(false)}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn-primary"
            disabled={request.delete_task.loading || request.delete_progress.loading}
            onClick={() => {
              destroyTask();
              setSaveClicked(true);
            }}
          >
            Continuar
          </button>
        </div>
      </Modal>
    );

  return (
    <Modal show={modalManagementTaskOpened} size="xl">
      <div className="modal-header">
        <h5 className="modal-title" id="staticBackdropLabel">
          {task ? 'Editar' : 'Adicionar'}
          {taskType === 'task' ? ' Tarefa' : ' Andamento'}
        </h5>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={() => {
            setModalManagementTaskOpened(false);
          }}
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div className="modal-body">
        {(request.create_tasks.loading ||
          request.update_tasks.loading ||
          request.create_progress.loading ||
          request.update_progress.loading) && (
          <div className="my-2 alert alert-warning text-center p-1 w-100 d-flex justify-content-center align-items-center">
            Salvando <SquareLoader customClass="visible load-save-task ml-2" />
          </div>
        )}
        {showError && (
          <div className="my-2 alert alert-danger text-center">
            <button
              type="button"
              id="close-alert"
              className="close"
              onClick={() => setShowError(false)}
            >
              ×
            </button>
            Erro
          </div>
        )}
        {showValidationError && (
          <div className="my-2 alert alert-danger text-center">
            <button
              type="button"
              id="close-alert"
              className="close"
              onClick={() => setShowValidationError(false)}
            >
              ×
            </button>
            Insira {title === '' ? 'o título' : 'a descrição'}{' '}
            {taskType === 'task' ? 'da tarefa' : 'do andamento'}
          </div>
        )}
        {showSuccess && (
          <div className="my-2 alert alert-success text-center">
            <button
              type="button"
              id="close-alert"
              className="close"
              onClick={() => setShowSuccess(false)}
            >
              ×
            </button>
            {taskType === 'task' ? `Tarefa salva com sucesso.` : `Andamento salvo com sucesso.`}
          </div>
        )}
        <div className="row">
          <div className="col-md-7">
            <div className="form-group">
              <label htmlFor="taskTitle">Título</label>
              <input
                className="form-control"
                id="taskTitle"
                name="taskTitle"
                type="text"
                value={title}
                onChange={(event) => setTitle(event.target.value)}
                disabled={isFieldDisabled()}
              />
            </div>
            <div className="form-group">
              <div className="d-flex justify-content-between">
                <label htmlFor="taskDescription">Descrição</label>
                <button
                  type="button"
                  className="btn btn-link p-0 btn-sm d-flex align-items-center text-decoration-none"
                  onClick={startRecording}
                  disabled={transcribing}
                >
                  {transcribing ? (
                    <div className="audio-loading-bars mr-2">
                      <span />
                      <span />
                      <span />
                    </div>
                  ) : (
                    <i className="material-icons mr-1">mic</i>
                  )}
                  Ditar texto
                </button>
              </div>
              {isRecording ? (
                <ContainerAudioPreview>
                  <div className="flex-grow-1">
                    <AudioWaveRecorder ref={waveRef} />
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="d-flex">
                      <button
                        type="button"
                        className="btn d-flex align-items-center p-0 audio-cancel"
                        onClick={cancelRecording}
                      >
                        <span className="material-icons">close</span>
                      </button>
                      <button
                        type="button"
                        className="btn d-flex align-items-center p-0 audio-submit ml-1"
                        onClick={() => stopRecording(handleRecordFinish)}
                      >
                        <span className="material-icons">check</span>
                      </button>
                    </div>
                  </div>
                </ContainerAudioPreview>
              ) : (
                <textarea
                  className="form-control"
                  id="taskDescription"
                  name="taskDescription"
                  rows={3}
                  value={taskDescription}
                  onChange={(event) => setTaskDescription(event.target.value)}
                  disabled={isFieldDisabled()}
                />
              )}
            </div>
            {task && (
              <div className="mb-3">
                <div className="mb-2 d-flex align-items-middle justify-content-between">
                  Anexos
                  <button
                    type="button"
                    className="float-right btn btn-link"
                    onClick={() => setAttachmentOpened(!attachmentOpened)}
                  >
                    Adicionar anexo
                  </button>
                </div>
                {attachmentOpened && (
                  <div className="mb-2 alert-secondary p-3 rounded">
                    {taskType === 'task' && request.create_task_attachment.loading && (
                      <div className="progress mb-2">
                        <div
                          className="progress-bar progress-bar-striped progress-bar-animated"
                          role="progressbar"
                          aria-valuenow={uploadProgress}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ width: `${uploadProgress}%` }}
                        />
                      </div>
                    )}
                    {taskType === 'progress' && request.create_progress_attachment.loading && (
                      <div className="progress mb-2">
                        <div
                          className="progress-bar progress-bar-striped progress-bar-animated"
                          role="progressbar"
                          aria-valuenow={uploadProgress}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ width: `${uploadProgress}%` }}
                        />
                      </div>
                    )}
                    {showAttachmentError && (
                      <div className="my-2 alert alert-danger text-center">
                        <button
                          type="button"
                          id="close-alert"
                          className="close"
                          onClick={() => setShowAttachmentError(false)}
                        >
                          ×
                        </button>
                        Erro ao anexar arquivo.
                      </div>
                    )}
                    <div className="col-md-12 mb-4 p-0">
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Insira uma descrição para o documento (Opcional)"
                        value={fileDescription}
                        onChange={(event) => setFileDescription(event.target.value)}
                      />
                      <input className="mt-2" type="file" onChange={handleFile} />
                    </div>
                    <div className="col-md-12 p-0">
                      <button
                        className="btn btn-sm btn-primary ml-auto"
                        type="button"
                        onClick={handleSubmit}
                      >
                        Salvar
                      </button>
                    </div>
                  </div>
                )}
                {task.bidding_attachments?.length > 0 ? (
                  <ul className="list-unstyled">
                    {task.bidding_attachments.map((attachment) => (
                      <AttachmentItem
                        key={attachment?.parsed_url}
                        createdAt={attachment.created_at}
                        description={attachment.description}
                        filename={attachment.filename}
                        url={attachment?.parsed_url}
                        deleteItem={() => dispatch(destroyTaskAttachment(attachment.id, task?.id))}
                      />
                    ))}
                  </ul>
                ) : (
                  <div className="mb-r">
                    <div className="text-center alert alert-secondary">
                      {taskType === 'task'
                        ? `Não existem anexos salvos para esta tarefa`
                        : `Não existem anexos salvos para este andamento`}
                    </div>
                  </div>
                )}
              </div>
            )}
            {task && (
              <div>
                <div className="row col-12 m-0 p-0 mb-2">
                  Anotações
                  <CommentInput
                    isLoading={request.create_task_comment.loading}
                    createComment={createManagementComment}
                  />
                </div>
                {_.sortBy(task.task_event_comments, (comment) => {
                  return Date.parse(comment.created_at);
                })
                  .reverse()
                  ?.map((event_comment) => (
                    <CommentItem
                      key={event_comment.id}
                      id={event_comment.id}
                      contact_client_id={event_comment.contact_client.id}
                      contact_client_nome={event_comment.contact_client.nome}
                      created_at={event_comment.created_at}
                      message={event_comment.description}
                      taskId={task.id}
                      commentSource="management"
                    />
                  ))}
              </div>
            )}
          </div>
          <div className="col-md-5">
            <div className="alert-secondary p-3">
              <dl className="m-0">
                <dt>Edital</dt>
                <dd>
                  <button
                    type="button"
                    className="btn btn-link p-0"
                    disabled={!bidding}
                    onClick={() =>
                      window.open(
                        `/minhas_licitacoes/management/${bidding?.id}/${companyId(profile)}`,
                        `management`,
                      )
                    }
                  >
                    {bidding?.edital || 'Licitação indisponível'}
                  </button>
                </dd>
                <dt>Unidade Licitante</dt>
                <dd className="mb-0">{bidding?.public_body?.nome}</dd>
                {bidding?.orgao_cidade && bidding?.orgao_estado && (
                  <dd>
                    {bidding?.orgao_cidade}/{bidding?.orgao_estado}
                  </dd>
                )}
              </dl>
            </div>
            <div className="form-group">
              <div className="my-3">
                {taskType === 'task' ? `Prazo` : `Data`}
                <br />
                <DatePicker
                  selected={deadlineDate}
                  onChange={(date) => {
                    if (date) setDeadLineDate(date);
                  }}
                  showTimeSelect
                  locale="el"
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  timeCaption="time"
                  className="form-control"
                  name="deadline"
                  dateFormat="Pp"
                  disabled={isFieldDisabled()}
                />
              </div>
              {task && taskType === 'task' && (
                <div className="my-3">
                  Data de Conclusão
                  <br />
                  <DatePicker
                    selected={finishedDate}
                    onChange={(date) => {
                      if (date) setFinishedDate(date);
                    }}
                    showTimeSelect
                    locale="el"
                    timeFormat="HH:mm"
                    timeIntervals={15}
                    timeCaption="time"
                    className="form-control"
                    name="finished"
                    dateFormat="Pp"
                    disabled={isFieldDisabled() || !selectedCompleted}
                  />
                </div>
              )}
              {taskType === 'task' && (
                <div className="my-3">
                  Responsável
                  <Select
                    name="responsible_id"
                    options={userContactsList}
                    value={_.findWhere(userContactsList, { value: selectedUserContact })}
                    onChange={(selected) => {
                      if (selected) setselectedUserContact(selected?.value);
                    }}
                    autoFocus
                    placeholder="Selecione o responsável"
                    isDisabled={isFieldDisabled()}
                  />
                </div>
              )}
              {taskType === 'task' && (
                <div
                  className={`mb-3 p-2 rounded ${
                    selectedCompleted ? 'bg-success text-white' : 'alert-secondary'
                  }`}
                >
                  <label className="m-0 d-flex align-items-middle" style={{ fontSize: '1rem' }}>
                    <InputCompleted
                      className="completed-check mx-3"
                      type="checkbox"
                      checked={selectedCompleted}
                      onChange={() => setSelectedCompleted(!selectedCompleted)}
                      disabled={isFieldDisabled()}
                    />
                    {selectedCompleted ? `Concluída` : `Marcar como concluída`}
                  </label>
                </div>
              )}
            </div>
            {!isFieldDisabled() && (
              <button
                type="button"
                className={`btn btn-md btn-block save-task-button ${
                  selectedCompleted ? 'btn-success' : 'btn-primary'
                }`}
                onClick={() => saveTask()}
                aria-label="Salvar Tarefa"
              >
                {taskType === 'task' ? `Salvar Tarefa` : `Salvar Andamento`}
              </button>
            )}
            {task && !isFieldDisabled() && (
              <DeleteButton
                type="button"
                className="btn btn-sm btn-block text-secondary delete-task-link"
                onClick={() => setDeletingTask(true)}
                aria-label="Excluir Tarefa"
              >
                {taskType === 'task' ? `Excluir Tarefa` : `Excluir Andamento`}
              </DeleteButton>
            )}
            {task && task?.task_event_histories.length > 0 && (
              <>
                <p className="mt-3 mb-1 font-weight-bold">Histórico de Eventos</p>
                <ul className="list-group">
                  {task?.task_event_histories.map((event) => (
                    <li className="list-group-item p-2 rounded-0">
                      <p className="m-0">
                        <strong>{event.contact_client.nome}</strong> {event.description}
                      </p>
                      <p className="m-0">
                        <i>{moment(event.created_at).format('L [às] LT')}</i>
                      </p>
                    </li>
                  ))}
                </ul>
              </>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ManagementTask;
